import { FirestorePaginator } from './FirestorePaginator'
import { Paginator } from './Paginator'

export default { Firestore: FirestorePaginator, Default: Paginator }
